/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::366baf66b1a43ca29896dfea5fa24833>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconNew = _interopRequireDefault(require("@atlaskit/icon/components/icon-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "DragHandleHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/drag-handle-horizontal
 * Usage guidance:
 * Reserved for dragging elements along a horizontal axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const DragHandleHorizontalIcon = props => /*#__PURE__*/_react.default.createElement(_iconNew.default, Object.assign({
  name: "DragHandleHorizontalIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" d="M2.75 9a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m0-5.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5M8 9a1.75 1.75 0 1 1 0 3.5A1.75 1.75 0 0 1 8 9m0-5.5A1.75 1.75 0 1 1 8 7a1.75 1.75 0 0 1 0-3.5M13.25 9a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m0-5.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
DragHandleHorizontalIcon.displayName = 'DragHandleHorizontalIcon';
var _default = exports.default = DragHandleHorizontalIcon;